import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import {getDeviceOnlineRate, getAllStationOnlineRate} from '@apis'
import * as G2 from '@antv/g2'

const DeviceOnlineRate = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {brokerId, strongProjectId: projectId} = userInfo

  
    async function queryOnlineRate() {
      const params = {
        projectId,
        brokerId
      }
      const res = projectId ? await getDeviceOnlineRate(params) : await getAllStationOnlineRate(params)
      if (res) {
        const total = res.online + res.offline
        const onlinePercent = (res.online / total).toFixed(4)
        const offlinePercent = 1 - onlinePercent
        const rateData = [
          {item: '在线', count: res.online, percent: Number(onlinePercent)},
          {item: '不在线', count: res.offline, percent: Number(offlinePercent)}
        ]
        creatChat(rateData, total)
      }
    }

    useEffect(() => {
      queryOnlineRate()
    }, [])
 
    function creatChat(data, totalData) {
      const chart = new G2.Chart({
        container: 'device-container',
        autoFit: true,
        height: 280,
      });
      chart.data(data);
      chart.scale('percent', {
        formatter: (val) => {
          val = val * 100 + '%';
          return val;
        },
      });
      chart.coordinate('theta', {
        radius: 0.75,
        innerRadius: 0.7,
      });
      chart.tooltip({
        showTitle: false,
        showMarkers: false,
        itemTpl: '<li class="g2-tooltip-list-item"><span style="background-color:{color};" class="g2-tooltip-marker"></span>{name}: {value}</li>',
      });
      // 辅助文本
      chart
        .annotation()
        .text({
          position: ['50%', '50%'],
          content: totalData.toFixed(0),
          style: {
            fontSize: 35,
            fill: '#fff',
            textAlign: 'center',
          },
          offsetY: -10,
        })
        .text({
          position: ['50%', '50%'],
          content: '配电柜总数',
          style: {
            fontSize: 20,
            fill: '#fff',
            textAlign: 'center',
          },
          offsetY: 14,
        })
      chart
        .interval()
        .adjust('stack')
        .position('percent')
        .color('item')
        .label('percent', (percent) => {
          return {
            content: (data) => {
              return `${data.item}: ${(percent * totalData).toFixed(0)}`;
            },
            style: {
              fill: '#fff',
              fontSize: 20
            }
          };
        })
        .tooltip('item*percent', (item, percent) => {
          percent = (percent * totalData).toFixed(0);
          return {
            name: item,
            value: percent,
          };
        });
      chart.legend({
        // position: 'left',
        itemName: {
          style: {
            fontSize: 12,
            fill: '#fff'
          }
        }
      })
  
      chart.interaction('element-active');
  
      chart.render();
    }

    return (
      <div className='ck-device-online'>
        <div className='title'>配电柜在线率</div>
        <div className='device-item'>
          <div id='device-container' className='monitor-chat'></div>
        </div>
      </div>
    )
  })
)

export default DeviceOnlineRate